import { useState, useEffect } from 'react';
import { Card, Input, Button, Table, Switch, message, Space, Tag, Modal, Form } from 'antd';
import { ApiOutlined, PlusOutlined } from '@ant-design/icons';
import api from '../services/api';

// 全局供应商授权。接口要求管理员登录（/api/admin/operator/*），页面挂在管理后台登录之后。

const OperatorAuth = () => {
  const [providers, setProviders] = useState([]);
  const [saving, setSaving] = useState({});
  const [addModalVisible, setAddModalVisible] = useState(false);
  const [addLoading, setAddLoading] = useState(false);
  const [addForm] = Form.useForm();

  useEffect(() => { fetchProviders(); }, []);

  const fetchProviders = async () => {
    try {
      const res = await api.get('/admin/operator/providers');
      if (res.code === 0) setProviders(res.data?.providers || []);
    } catch (e) { message.error('加载失败'); }
  };

  const toggleProvider = async (providerId, checked) => {
    setSaving(prev => ({ ...prev, [providerId]: true }));
    const newProviders = providers.map(p =>
      p.id === providerId ? { ...p, authorized: checked } : p
    );
    setProviders(newProviders);
    try {
      const ids = newProviders.filter(p => p.authorized).map(p => p.id);
      await api.post('/admin/operator/update-providers', { provider_ids: ids });
    } catch (e) { message.error('更新失败'); fetchProviders(); }
    setSaving(prev => ({ ...prev, [providerId]: false }));
  };

  const handleAddProvider = async (values) => {
    setAddLoading(true);
    try {
      const res = await api.post('/admin/operator/add-provider', values);
      if (res.code === 0) { message.success('供应商已添加'); setAddModalVisible(false); addForm.resetFields(); fetchProviders(); }
      else { message.error(res.message || '添加失败'); }
    } catch (e) { message.error('添加失败'); }
    setAddLoading(false);
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', width: 60 },
    { title: '供应商名称', dataIndex: 'display', width: 160 },
    { title: '标识', dataIndex: 'name', width: 100 },
    { title: 'API地址', dataIndex: 'api_base', width: 280, ellipsis: true },
    { title: '状态', dataIndex: 'status', width: 80, render: s => <Tag color={s === 'active' ? 'green' : 'default'}>{s === 'active' ? '启用' : '停用'}</Tag> },
    { title: '授权接入', width: 100, render: (_, r) => (
      <Switch checked={r.authorized} onChange={v => toggleProvider(r.id, v)} loading={saving[r.id]} />
    )},
  ];

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h2 style={{ margin: 0 }}><ApiOutlined style={{ color: '#1677ff', marginRight: 8 }} />供应商接入管理</h2>
        <Space>
          <Button icon={<PlusOutlined />} onClick={() => setAddModalVisible(true)}>添加供应商</Button>
          <Button onClick={fetchProviders}>刷新</Button>
        </Space>
      </div>
      <Card>
        <Table dataSource={providers} columns={columns} rowKey="id" scroll={{ x: 800 }}
          pagination={false} size="small" />
      </Card>

      <Modal title="添加供应商" open={addModalVisible} onCancel={() => { setAddModalVisible(false); addForm.resetFields(); }} footer={null}>
        <Form form={addForm} layout="vertical" onFinish={handleAddProvider}>
          <Form.Item name="name" label="标识" rules={[{ required: true, message: '请输入供应商标识' }]} extra="唯一标识，如 deepseek、qwen">
            <Input placeholder="如: custom-api" />
          </Form.Item>
          <Form.Item name="display_name" label="显示名称" rules={[{ required: true, message: '请输入显示名称' }]}>
            <Input placeholder="如: 自定义API" />
          </Form.Item>
          <Form.Item name="api_base" label="API地址" rules={[{ required: true, message: '请输入API地址' }]}>
            <Input placeholder="https://api.example.com/v1" />
          </Form.Item>
          <Form.Item name="api_key" label="API密钥" rules={[{ required: true, message: '请输入API密钥' }]}>
            <Input.Password placeholder="sk-xxx" />
          </Form.Item>
          <Button type="primary" htmlType="submit" block loading={addLoading}>确认添加</Button>
        </Form>
      </Modal>

    </div>
  );
};

export default OperatorAuth;
